module.exports = __webpack_public_path__ + "static/media/tachometer-slow.f217f2ad.svg";